import { AlertBanner } from './AlertBanner';

export default AlertBanner;
